export default __webpack_public_path__ + "static/media/evening_filled.047d29f5.svg";